import React from 'react';
import PropTypes from "prop-types";
import {Button, PopupWindow, InputInformation, InputList, Components} from 'dts-react-common';
import webservice from '../app/Webservice';
import {connect} from 'react-redux';
import {dispatchUpdateData} from '../common/Shared';

const propTypes = {
	agency: PropTypes.object.isRequired,
	correction: PropTypes.object.isRequired,
	workLocation: PropTypes.object.isRequired,
};

const defaultProps = {};

const mapStateToProps = (state) => {
	return {
		agency: state.dataList.agency,
		correction: state.app.correction,
		workLocation: state.dataList.workLocation
	};
};

class OfferDetails extends React.Component {
    constructor(props) {
        super(props);

        this.inputs = [
            new InputInformation({field: 'workingTitle', label: "Working Title", type: Components.TEXT_INPUT, className: "stack-form"}),
            new InputInformation({field: 'hiringManager', label: "Hiring Manager", type: Components.TEXT_INPUT, className: "stack-form"}),
            new InputInformation({field: 'agencyFk', label: "Agency", type: Components.SELECT_INPUT, options: this.props.agency, className: "stack-form"}),
            new InputInformation({field: 'hiringManagerPhone', label: "Hiring Manager Phone", type: Components.TEXT_INPUT, className: "stack-form"}),
            new InputInformation({field: 'startDate', label: "Start Date", type: Components.CALENDAR_INPUT, className: "stack-form"}),
            new InputInformation({field: 'hiringManagerEmail', label: "Hiring Manager Email", type: Components.TEXT_INPUT, className: "stack-form"}),
            new InputInformation({field: 'wage', label: "Wage", type: Components.TEXT_INPUT, className: "stack-form"}),
            new InputInformation({field: 'recruiter', label: "Recruiter", type: Components.TEXT_INPUT, className: "stack-form"}),
            new InputInformation({field: 'workLocationFk', label: "Work Location", type: Components.SELECT_INPUT, options: this.props.workLocation, className: "stack-form"}),
            new InputInformation({field: 'recruiterPhone', label: "Recruiter Phone", type: Components.TEXT_INPUT, className: "stack-form"}),
            new InputInformation({field: 'recruiterEmail', label: "Recruiter Email", type: Components.TEXT_INPUT, className: "stack-form"})
        ];

        this.inputs.forEach(input => {
            input.onChange = (field, value) => dispatchUpdateData({path: 'app.correction', field: field, value: value});
        });
    }

    render() {
        return (
            <PopupWindow
                onCloseButtonCallback={() => dispatchUpdateData({path: 'app', field: 'showEdit', value: false})}
                className="popup-window--large"
                footerChildren={(
                    <div className="message-popup__footer--single">
                        <Button
                            label="Cancel"
                            onClick={() => dispatchUpdateData({path: 'app', field: 'showEdit', value: false})}
                            className="button button--solid complementary mr-spacing"
                        />
                        <Button
                            label="Save"
                            onClick={() => webservice.corrections.send(this.props.correction).then(dispatchUpdateData({path: 'app', field: 'showEdit', value: false}))}
                            className="button"
                        />
                    </div>
                )} >
                <h2>Offer Details Corrections</h2>
                <p>Please update any of the fields that are incorrect. Selecting "Save" will send the updates to Human Resources.</p>
                <div className="flex-children flex-children-wrap">
                    <InputList inputs={this.inputs} data={this.props.correction} />
                </div>
            </PopupWindow>
        );
    }
}

OfferDetails.PropTypes = propTypes;
OfferDetails.defaultProps = defaultProps;

export default connect(mapStateToProps)(OfferDetails);